var map = {
	"./cockpit-color-icon.png": 68257,
	"./goodin-color-icon.png": 13841,
	"./goodin-icon.png": 47482,
	"./hub-color-icon.png": 5485,
	"./hub-icon.png": 713,
	"./keepup-color-icon.png": 35922,
	"./keepup-icon.png": 61894,
	"./knowlake-color-icon.png": 71049,
	"./knowlake-icon.png": 4522,
	"./ksm-color-icon.png": 7568,
	"./lab-icon.png": 25,
	"./lib-icon.png": 55734,
	"./logicprint5-color-icon.png": 10767,
	"./logicprint5-icon.png": 76085,
	"./logicprint7-color-icon.png": 32692,
	"./logicprint7-icon.png": 7527,
	"./packos-color-icon.png": 57480,
	"./packos-icon.png": 35487,
	"./workboost-color-icon.png": 52311,
	"./workboost-icon.png": 62656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24185;